module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav",
    class: _vm.navClasses
  }, [_c('li', [(_vm.checkLogin) ? _c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": "/",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Dashboard")])]) : _vm._e()], 1), (_vm.checkLogin) ? _c('li', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeDropdown),
      expression: "closeDropdown"
    }],
    staticClass: "dropdown",
    class: {
      open: _vm.isDropdownOpened
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openDropdown($event)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-bell"
  }), _c('span', {
    staticClass: "notification"
  }, [_vm._v("98")]), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Notifications")])]), _vm._m(0)]) : _vm._e(), (_vm.checkLogin) ? _c('li', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeProfileDropdown),
      expression: "closeProfileDropdown"
    }],
    staticClass: "dropdown",
    class: {
      open: _vm.isProfileDropdownOpened
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openProfileDropdown($event)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user"
  }), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Profile")]), _c('span', [_vm._v(_vm._s(this.$user.email || 'Welcome !'))])]), (_vm.checkLogin) ? _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(this.$user.email))])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('My Profile')))])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Logout')))])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mike John responded to your email")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("You have 5 new tasks")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("You're now friend with Andrew")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another Notification")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another One")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da18b1aa","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation/navbar-right.vue
// module id = GiJD
// module chunks = 13 14